<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text>{{text}}</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined elevation="3" color="error" @click="define">确定</v-btn>
          <v-btn
            text
            @click="cancel"
          >
            取消
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style></style>
<script>

  export default {
    name: "alert",
    data() {
      return {
        alignment: 'center',
        justify: 'center',
        title: "提示",
        text: "默认内容",
        dialog: true,
        dark: false
      }
    },
    methods: {
      define() {
        this.dialog = false;
        this.$el.remove() //再点击关闭得时候要将其移出，（仅在第一种方法中使用）
        this.confirmSure()
        this.$destroy()
      },
      cancel(){
        this.dialog = false;
        this.$el.remove() //再点击关闭得时候要将其移出，（仅在第一种方法中使用）
        this.$destroy()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/dialog/confirm/Confirm.vue